import { route } from 'ziggy-js'
import { Ziggy } from './generated/ziggy'

/**
 *
 * @param name
 * @param params
 * @param absolute
 * @returns {String}
 */
export default function (name, params = {}, absolute = false) {
    return route(name, params, absolute, Ziggy)
}
